import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import TaxeSelectionComponent from 'components/taxes/TaxeSelectionComponent'
import ColorPickerComponent from 'routes/Admin/components/CommonComponents/ColorPickerComponent'
const styles = theme => ({
  formControl: {
    // margin : `0 ${theme.spacing.unit}px`
  },
  group: {
    margin: `${theme.spacing.unit}px 0`
  }
})

class CategoryModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    category: PropTypes.object,
    taxes: PropTypes.array,
    updateCategory: PropTypes.func,
    createCategory: PropTypes.func,
    categoryNames: PropTypes.array,
    hideModal: PropTypes.func
  }
  static defaultProps = {
    categoryNames: []
  }
  state = {
    category: {
      name: '',
      color: '',
      tva: void 0
    },
    isValid: false,
    errors: {},
    helpers: {}
  }
  updateState = nextState => {
    const { category } = nextState
    const categoryProps = this.props.category
    let isValid = true
    let helpers = {}
    if (
      !categoryProps &&
      this.props.categoryNames.includes(_.lowerCase(category.name))
    ) {
      helpers.name = 'Une autre catégorie existe déjà avec ce nom'
    }
    if (categoryProps && isValid) {
      isValid = !_.isEqual(categoryProps, category)
    }
    this.setState({ ...nextState, isValid, helpers })
  }
  handleChange = name => (e, val) => {
    const isChecker = e.target.value === 'checker'
    let value = isChecker ? e.target.checked : val || e.target.value
    this.updateState({
      ...this.state,
      category: { ...this.state.category, [name]: value }
    })
  }
  handleTvaChange = tva => {
    this.updateState({
      ...this.state,
      category: { ...this.state.category, tva: tva }
    })
  }
  handleColorSelection = name => color => {
    this.updateState({
      ...this.state,
      category: { ...this.state.category, [name]: color }
    })
  }

  handleOnCreate = () => {
    const { category } = this.state
    this.props.createCategory(category)
  }
  handleOnUpdate = () => {
    const { category } = this.state
    this.props.updateCategory(this.props.category, category)
  }

  colorPicker = classes => {
    const { category } = this.state
    return (
      <ColorPickerComponent
        className={classes.colorControl}
        colorValidate={this.handleColorSelection('color')}
        color={category.color}
      />
    )
  }
  componentDidMount() {
    const { category, taxes } = this.props
    let nextState = { ...this.state }
    if (category) {
      nextState = { category: { ...category } }
    } else if (taxes) {
      nextState.category.tva = taxes.filter(t => !!Number(t.tax_default))[0]
    }
    this.updateState(nextState)
  }
  render() {
    const { classes, taxes } = this.props
    const { helpers, isValid, category } = this.state
    const isCreate = !this.props.category
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={isCreate ? this.handleOnCreate : this.handleOnUpdate}
        title={isCreate ? 'Ajouter une catégorie' : `Editer ${category.name}`}
        okDisabled={!isValid}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between">
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="name"
                helperText={helpers.name || null}
                required
                label="Nom"
                onChange={this.handleChange('name')}
                value={category.name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <TaxeSelectionComponent
                onChange={this.handleTvaChange}
                taxes={taxes}
                selectedTaxe={category.tva}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              {this.colorPicker(classes)}
            </Grid>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(CategoryModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Categories/components/CategoryModal.js